<script setup lang="ts">
const mockupData = [
    {
        image: '/static/images/benefit-img1a.png',
        title: 'Fans Love It',
        description:'Connect with your fans on a whole new level with livestreams and real-time highlights that make the game even more exciting.',
        image_position:'top'
    },
    {
        image: '/static/images/benefit2a.png',
        title: 'Get Noticed',
        description:'Generate buzz and attract sponsors with engaging content that sets you apart in the sports industry.',
        image_position:'top'
    },
    {
        image: '/static/images/benefit3a.png',
        title: 'Remember the Best Plays',
        description:'Preserve and relive the most thrilling and unforgettable plays of the game, ensuring they are never forgotten.',
        image_position:'top'
    },
    {
        image: '/static/images/benefit4a.png',
        title: 'Unlock New Revenue Streams',
        description:'Seamlessly integrate sponsor ads into your videos to unlock new opportunities for revenue.',
        image_position:'top'
    },
    {
        image: '/static/images/benefit5a.png',
        title: 'Strengthen Brand Presence',
        description:'Easily integrate livestreams and highlights to your website or app, allowing fans to enjoy the action on your platform.',
        image_position:'bottom'
    },
    {
        image: '/static/images/benefit6a.png',
        title: 'Elevate Your Game',
        description:'Analyze, review, and improve your plays with valuable insights to enhance your performance.',
        image_position:'top'
    }
]
</script>

<template>
    <section>
        <div class="container">
            <div class="row justify-content-center mb-5">
                <div class="col-60 col-lg-28 text-lg-center">
                    <h2 class="alfa mb-2">
                        Experience the power<br>
                        <strong>of the Sport.Video app</strong>
                    </h2>
                    <p class="beta">
                        From enhanced fan engagement to revenue growth.<br>
                        Discover the advantages that propel you forward.
                    </p>
                </div>
            </div>

            <div class="row g-1">

                <div class="col-60 col-md-30 col-lg-20" v-for="(item, index) in mockupData" :key="`chs-${index}`">
                    <BenefitBox
                        :title="item.title"
                        :description="item.description"
                        :image="item.image"
                        :image-position="item.image_position"
                    />
                </div>
            </div>
        </div>
    </section>
</template>

<style lang="scss" scoped>
section {
    border-radius: 3rem;
    background: linear-gradient(180deg, #e3e3e3 0%, rgba(244, 245, 247, 0) 100%);
}
</style>
